import "./data-table.component.scoped.sass";
import { TableProps } from "../../types/talble-props";
import React from "react";
import { ViewToolsComponent } from "../view-tools/view-tools.component";
import { TableContentComponent } from "../table-content/table-content.component";
import { CalendarContentComponent } from "../calendar-content/calendar-content.component";
import { TableColumn } from "../../types/table-column";
import { formattedTableDateString, arrayToString } from "../../helpers";
import { useTranslation } from "react-i18next";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import moment from "moment";

export const DataTableComponent = (props: TableProps) => {
  const { mode, data, allData, options, pagination, columns, toggleView, refresh, search, sort, paginate, loading, title, total, clickableRow } = props;
  const [t] = useTranslation();
  const tools = {
    exportCsv() {
      let csvContent = "data:text/csv;charset=utf-8,%EF%BB%BF";
      columns.forEach((column: TableColumn) => {
        if (column.type === 'weekly-monthly') {
          csvContent += `${t(column.value)} [${t('week')}], ${t(column.value)} [${t('month')}],`;
        } else if (column.type === 'activities-hours' && column.secondaryValue) {
          csvContent += `${t(column.value)} ${t(column.secondaryValue)},`;
        } else if (column.type === 'user') {
          csvContent += `${t('firstName')}, ${t('lastName')},`;
        } else if (column.value !== 'actions') {
          csvContent += `${t(column.value)},`
        }
      })
      csvContent += "\n";
      allData.forEach((row: any) => {
        columns.forEach((column: TableColumn, index: number) => {
          if (column.type !== 'actions') {
            const last = index === columns.length - 1;
            const value = column.type === 'user' 
              ? `"${row[column.fieldName].firstName}","${row[column.fieldName].lastName}"`
              : column.type === 'tasks'
              ? `"${arrayToString(row[column.fieldName])}"`
              : column.type === 'date'
              ? `"${formattedTableDateString(row[column.fieldName])}"`
              : column.type === 'weekly-monthly'
              ? `${row[column.fieldName].weekly}, ${row[column.fieldName].monthly}`
              : column.type === 'activities-hours'
              ? `${row[column.fieldName].hours}: ${row[column.fieldName].minutes} / ${row['activities']}`
              : `"${row[column.fieldName]}"`
            csvContent += `${value} ${ !last ? ',' : ''}`;
          }
        });
        csvContent += "\n";
      });
      var downloadLink = document.createElement("a");
      downloadLink.href = csvContent;
      const today = moment().format("YYYY-MM-DD");
      let exportName = title;
      exportName = exportName[0].toUpperCase() + exportName.slice(1); ;
      downloadLink.download = `${exportName} ${today}.csv`;

      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },
    print() {
      window.print();
    },
    refresh: () => refresh(),
    search: (...args: any) => search(...args),
    sort: (...args: any) => sort(...args)
  };
  return (
    <div className="wrapper">
      <div className="view-tools-wrapper">
        <ViewToolsComponent
          mode={mode}
          options={options}
          toggleView={toggleView}
          tools={tools}
          title={title}
          total={total}
        />
      </div>
      <div className="table-wrapper">
        <div className="table-container">
          {loading && !data?.length && (
            <div className="loader-area">
              <CircularProgress />
            </div>
          )}
          {mode === "table" ? (
            <TableContentComponent
              options={options}
              data={data}
              columns={columns}
              tools={tools}
              loading={loading}
              title={title}
              paginate={paginate}
              pagination={pagination}
              clickableRow={clickableRow}
            />
          ) : (
            <CalendarContentComponent />
          )}
        </div>
      </div>
    </div>
  );
};
